/**
 * Registro aberto esconde o cabecalho da secao.
 *
 * Ver e editar sao PAGINA INTEIRA: com um registro aberto, o titulo da pagina passa a ser ele, com
 * o caminho de volta para a colecao. Manter o cabecalho da secao em cima empilharia dois titulos
 * grandes - "Clientes" e o nome do cliente - e empurraria o formulario para baixo da dobra.
 *
 * Quem sabe que ha registro aberto e a listagem; quem desenha o cabecalho e o `App`. O contexto e a
 * ponte entre os dois, sem tirar da listagem o estado que e dela.
 */

import {
  createContext,
  useContext,
  useLayoutEffect,
  useMemo,
  useState,
  type ReactNode,
} from 'react'

const Contexto = createContext<{ aberto: boolean; marcar: (aberto: boolean) => void }>({
  aberto: false,
  marcar: () => undefined,
})

export function ProvedorDeRegistro({ children }: { children: ReactNode }) {
  const [aberto, marcar] = useState(false)
  const valor = useMemo(() => ({ aberto, marcar }), [aberto])
  return <Contexto.Provider value={valor}>{children}</Contexto.Provider>
}

export function useRegistroAberto(): boolean {
  return useContext(Contexto).aberto
}

/**
 * Chamado pela listagem. Efeito de LAYOUT, e nao comum: com o comum, a primeira pintura do registro
 * ainda saia com o cabecalho da secao em cima, e a tela pulava.
 */
export function useMarcarRegistroAberto(aberto: boolean): void {
  const { marcar } = useContext(Contexto)
  useLayoutEffect(() => {
    marcar(aberto)
    return () => marcar(false)
  }, [aberto, marcar])
}
